module.exports = __webpack_public_path__ + "img/apep_principle.73a95e34.png";